import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/loading-icon.gif'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container__standard-header container__standard-header--modify" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row--log-into-client-zone" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {},
    src: _imports_0,
    alt: "loading-to-the-client-zone",
    "cy-data": "blackout"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.redirectToTheClientZoneHeader`)), 1),
    _hoisted_3
  ]))
}